/**
 * Payment code helpers shared by the plan create, edit and info screens.
 */

// Note: default_provider is shown as Custom Provider and needs a provider
// name, which Open Dental reads from ledger_provider_name.
export const hasBlankCustomProvider = (paymentCodes = []) =>
  paymentCodes.some(
    (code) =>
      code?.ledger_provider_mode === 'default_provider' &&
      !code.ledger_provider_name?.trim(),
  );
